/**
 * Validates email
 * Pattern: local part + @ + domain + . + TLD (2–63 letters).
 */
const DEALER_EMAIL_REGEX =
  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/;

export function validateEmail(value: string | null | undefined): boolean {
  return DEALER_EMAIL_REGEX.test(value ?? "");
}
